import { render } from "./BuildingKitAiTestingOld.vue?vue&type=template&id=7f1a1a38&scoped=true&lang=pug"
import script from "./BuildingKitAiTestingOld.vue?vue&type=script&lang=js"
export * from "./BuildingKitAiTestingOld.vue?vue&type=script&lang=js"

import "./BuildingKitAiTestingOld.vue?vue&type=style&index=0&id=7f1a1a38&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1a1a38"]])

export default __exports__